<div class="routing-rules">

  <sc-master-detail [selection]="[selectedRule]" [data]="rules" (selectionChanged)="onSelectionChanged($event);"
    [newStyle]="true" (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <form #routingRulesForm="ngForm" class="form">
      <ng-container *ngIf="workingCopyRule != null">
        <sc-flex>

          <mat-form-field appearance="fill" class="field-name">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
            </mat-label>
            <input matInput [(ngModel)]="workingCopyRule.name" #ctrlName="ngModel" name="rr_name" [required]="true"
              [maxlength]="255">
          </mat-form-field>

          <sc-content-spacer></sc-content-spacer>

          <mat-form-field class="field-transport-option" appearance="fill">
            <mat-label>
              <sc-dictionary-label
                dictionaryKey="tmc-yard.ui.admin.routing-rule.rule.transport-option"></sc-dictionary-label>
            </mat-label>
            <mat-select [(ngModel)]="workingCopyRule.transportOptionId" name="rr_transport_option"
              #ctrlTransportOption="ngModel" [required]="true">

              <ng-container *ngFor="let to of transportOptions">
                <mat-option [value]="to.id">
                  <sc-dictionary-label [dictionaryKey]="to.name"></sc-dictionary-label>
                </mat-option>

                <ng-container *ngFor="let child of to.children">
                  <mat-option [value]="child.id">
                    &nbsp;&nbsp;
                    <sc-dictionary-label [dictionaryKey]="child.name"></sc-dictionary-label>
                  </mat-option>
                </ng-container>

              </ng-container>

            </mat-select>
          </mat-form-field>

          <sc-content-spacer></sc-content-spacer>

          <mat-form-field appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.routing-rule.rule.sort-order"></sc-dictionary-label>
            </mat-label>
            <input matInput [(ngModel)]="workingCopyRule.sortOrder" #ctrlSortOrder="ngModel" name="rr_sortOrder"
              [required]="false" [maxlength]="10">
          </mat-form-field>

        </sc-flex>
        <div class="form-box positions-list no-field-space">
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <sc-flex vertical stretchContent>
              <sc-tile *ngFor="let position of workingCopyRule.positions">
                <div class="draggable-form-box grid" cdkDrag>

                  <div class="row-flex" style="grid-column: 1; grid-row: 1;">
                    <mat-form-field class="grow" appearance="fill">
                      <mat-label>
                        <sc-dictionary-label
                          dictionaryKey="tmc-yard.ui.station-selection-dialog.title"></sc-dictionary-label>
                      </mat-label>
                      <input matInput [(ngModel)]="position.stationName" #ctrlPositionSelectStation="ngModel"
                        name="{{getPositionSelectStationFieldName(workingCopyRule, position)}}" [required]="true"
                        [readonly]="true">

                      <sc-action-icon matSuffix iconClass="fa-search" (click)="assignStation(position, form)"
                        iconClass="fa-sitemap"></sc-action-icon>
                    </mat-form-field>

                  </div>
                  <mat-form-field style="grid-column: 2; grid-row: 1;" class="action-type-field" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label
                        dictionaryKey="tmc-yard.ui.admin.routing-rule.position.action-type"></sc-dictionary-label>
                    </mat-label>
                    <mat-select [(ngModel)]="position.actionType" required="true"
                      name="{{getPositionActionTypeFieldName(workingCopyRule, position)}}"
                      [disabled]="isActionTypeDisabled(position)">
                      <mat-option *ngFor="let o of actionTypeOptions" value="{{o.option}}">
                        <sc-dictionary-label
                          dictionaryKey="tmc-yard.ui.admin.routing-rule.position.action-type.{{o.name}}"></sc-dictionary-label>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="grid-column: 3; grid-row: 1;" class="action-type-field" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label
                        dictionaryKey="tmc-yard.ui.admin.routing-rule.position.processingstatusmodel"></sc-dictionary-label>
                    </mat-label>
                    <mat-select [(ngModel)]="position.processingStatusModel" name="processingStatusModel">
                      <mat-option [value]="null">
                        <sc-dictionary-label dictionaryKey="tmc.stationgroup.no-processing-model"></sc-dictionary-label>
                      </mat-option>
                      <mat-option *ngFor="let statusModel of processingStatusModels" [value]="statusModel.key">
                        <sc-dictionary-label [dictionaryKey]="statusModel.nameDictionaryKey"></sc-dictionary-label>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="row-flex" style="grid-column: 4; grid-row: 1;">
                    <sc-action-icon
                      iconClass="fa-tasks {{  (!position?.tasks || position?.tasks?.length === 0) ? 'no-tasks' : ''}}"
                      (click)="assignTasks(position, form)"></sc-action-icon>
                  </div>

                  <mat-checkbox style="grid-column: 1; grid-row: 2;" class="form-checkbox"
                    [(ngModel)]="position.waitingForRetrieve"
                    name="{{getPositionWaitingForRetrieveCheckboxName(workingCopyRule, position)}}"
                    [disabled]="isWaitingForRetrieveDisabled(position)">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.routing-rule.position.waiting-for-retrieve"></sc-dictionary-label>
                  </mat-checkbox>

                  <mat-checkbox style="grid-column: 2; grid-row: 2;" class="form-checkbox"
                    [(ngModel)]="position.cargoMandatory"
                    name="{{getPositionCargoMandatoryCheckboxName(workingCopyRule, position)}}"
                    [disabled]="isCargoMandatoryDisabled(position)">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.routing-rule.position.cargo-mandatory"></sc-dictionary-label>
                  </mat-checkbox>

                  <mat-form-field style="grid-column: 3 / span 2; grid-row: 2;" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label
                        dictionaryKey="tmc-yard.ui.admin.routing-rule.rule.predicted-duration"></sc-dictionary-label>
                    </mat-label>
                    <input matInput [(ngModel)]="position.predictedDuration" #predictedDuration="ngModel"
                      name="{{getPredictedDurationFieldName(workingCopyRule, position)}}" [required]="true"
                      [disabled]="isPredictedDurationDisabled(position)" appPositiveInteger type="number" min="0">
                  </mat-form-field>

                  <mat-form-field style="grid-column: 1; grid-row: 3;" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label
                        dictionaryKey="tmc-yard.common.entity.station-assignment-strategy"></sc-dictionary-label>
                    </mat-label>
                    <mat-select [(ngModel)]="position.stationAssignmentStrategy"
                      [required]="isStationAssignmentStrategyRequired(position)"
                      [disabled]="isStationAssignmentStrategyDisabled(position)"
                      name="{{getAssignToProcessingStationFirstFieldName(workingCopyRule, position)}}">
                      <mat-option *ngFor="let o of stationAssignmentStrategyOptions" value="{{o}}">
                        <sc-dictionary-label
                          dictionaryKey="tmc-yard.common.entity.station-assignment-strategy.{{o}}"></sc-dictionary-label>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="grid-column: 2 / span 3; grid-row: 3;" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label
                        dictionaryKey="tmc-yard.entity.transport.currentPosition.hint"></sc-dictionary-label>
                    </mat-label>
                    <input matInput [(ngModel)]="position.hint" name="{{getHintFieldName(workingCopyRule, position)}}"
                      [required]="false" [maxLength]="1024">
                  </mat-form-field>

                  <div class="button-bar" style="grid-column: 5; grid-row: 1 / span 5;">
                    <sc-action-icon iconClass="fa-minus-circle" (click)="removePosition(position)" large></sc-action-icon>
                  </div>

                </div>
              </sc-tile>
            </sc-flex>
          </div>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex centered>
          <sc-add-action-button large (click)="addPosition()"></sc-add-action-button>
        </sc-flex>
      </ng-container>

    </form>

    <ng-template masterDetailToolbar>
      <sc-cancel-button type="button" (click)="cancel()" [disabled]="cancelDisabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary type="button" (click)="save()" [disabled]="saveDisabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>

</div>
